import {
  MimeType,
  SUPPORTED_MIME_TYPES,
} from '@stereograph/teia-system-design/components/DocumentViewer';

export const getMimeType = (filename: string): MimeType | undefined => {
  const parts = filename.toLowerCase().split('.');
  if (parts.length < 2) {
    return;
  }

  const lastExt = parts.pop();

  if (!lastExt) {
    return;
  }

  const mimeTypes: Record<string, string> = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    gif: 'image/gif',
    pdf: 'application/pdf',
    txt: 'text/plain',
    json: 'application/json',
    csv: 'text/csv',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    mp4: 'video/mp4',
    mp3: 'audio/mpeg',
    zip: 'application/zip',
    rar: 'application/vnd.rar',
  };

  const currentMimeType = mimeTypes[lastExt];

  const mimeType = SUPPORTED_MIME_TYPES.find(
    (mimeType) => mimeType === currentMimeType);

  return mimeType;
};
